import { useCallback } from 'react'
import { useFormikContext } from 'formik'
import { DUPLICATE_MESSAGE } from 'modules/Leads/NewLead/constants'
import { useAppSelector } from 'store'

const getMessage = (value: string | undefined, fieldName: keyof typeof DUPLICATE_MESSAGE) => {
  if (!value) return ''

  if (value === 'exact') {
    return DUPLICATE_MESSAGE[fieldName]?.exact
  }
  if (value === 'potential') {
    return DUPLICATE_MESSAGE[fieldName]?.potential
  }
  return ''
}

const useErrorMessage = <T>() => {
  const { leadDuplicate } = useAppSelector((state) => state.lead)
  const { getFieldMeta, errors, touched, values, submitCount } = useFormikContext<T>()

  const getFieldErrMsg = useCallback(
    (fieldName: keyof T) => {
      const { value, error, touched } = getFieldMeta(fieldName as string)

      if (!touched && submitCount === 0) return ''

      if (error) return error

      if (leadDuplicate?.reasons) {
        if (fieldName === 'companyInfo.name') {
          return getMessage(leadDuplicate.reasons.company_name, 'companyName')
        }
        if (fieldName === 'companyInfo.registrationNumber') {
          return getMessage(leadDuplicate.reasons.reg_no, 'registrationNumber')
        }
        if (fieldName === 'companyInfo.website') {
          return getMessage(leadDuplicate.reasons.website, 'website')
        }

        if (typeof fieldName === 'string' && typeof value === 'string') {
          if (fieldName.includes('contactPerson.email')) {
            const reason = leadDuplicate.reasons.email_address?.find((item) => item.value === value)
            return reason ? getMessage(reason.status, 'email') : ''
          }
          if (fieldName.includes('contactPerson.mobile')) {
            const reason = leadDuplicate.reasons.mobile?.find((item) => item.value === value)
            return reason ? getMessage(reason.status, 'mobile') : ''
          }
        }
      }

      return ''
    },
    [leadDuplicate, getFieldMeta, errors, touched, values], // eslint-disable-line react-hooks/exhaustive-deps
  )

  return [getFieldErrMsg]
}

export default useErrorMessage
